// extracted by mini-css-extract-plugin
export var quantityInput = "_gi-0";